import { ApiResponse, axiosInstance } from '@/lib/axios';
import { MutationConfig, TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

/**
 *
 */
export const DeleteCASTQuestionConfigSchema = z.object({
  csatQuestionId: z.string({ required_error: 'CAST Question ID is required!' }).uuid(),
});
export type TDeleteCASTQuestionConfigInput = z.infer<typeof DeleteCASTQuestionConfigSchema>;
export type TDeleteCASTQuestionConfigResponse = ApiResponse<{
  message: string;
}>;

export const deleteCASTQuestionConfig = async (
  data: TDeleteCASTQuestionConfigInput
): Promise<TDeleteCASTQuestionConfigResponse> => {
  const url = `/csat/config/question/${data.csatQuestionId}`;

  return axiosInstance.delete(url);
};

/**
 * React Query Hooks
 */
type UseDeleteCASTQuestionConfigOptions = {
  mutationConfig?: TypedMutationConfig<typeof deleteCASTQuestionConfig>;
};

export const useDeleteCASTQuestionConfig = ({ mutationConfig }: UseDeleteCASTQuestionConfigOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: deleteCASTQuestionConfig,
    ...restConfig,
  });
};
